<template>
  <div class="mt-5">
    <div class="d-flex flex-direction-row align-items-center">
      <div style="width: 50%">
        <span
          class="pendente-state"
          :class="{ 'pedido-ativo': filtroPendente }"
          @click="filtroPendente = false"
        >
          Pendentes
        </span>
        <span
          class="pedido-state ml-5"
          :class="{ 'pedido-ativo': !filtroPendente }"
          @click="filtroPendente = true"
        >
          Entregues
        </span>
      </div>
      <div class="d-flex justify-content-end" style="width: 50%">
        <Filters :showMonth="true" @changeDate="handleDateChange" />
      </div>
    </div>
    <div v-if="!filtroPendente">
      <PedidosList
        class="mb-5 mr-23 mt-3"
        v-for="(order, index) in Object.keys(unpaindOrders)"
        :key="order"
        :items="unpaindOrders[order]"
        :number="index"
        :currentCity="order"
        :searchValue="searchValue"
      />
    </div>
    <div v-if="filtroPendente">
      <PedidosList
        class="mb-5 mr-23 mt-3"
        v-for="(order, index) in Object.keys(paidOrders)"
        :key="order"
        :items="paidOrders[order]"
        :number="index"
        :currentCity="order"
        :searchValue="searchValue"
      />
    </div>
  </div>
</template>

<script>
import { Orders } from '../../services/Order';
import Filters from '../Filters.vue';
import PedidosList from './PedidosList.vue';

export default {
  components: { PedidosList, Filters },
  data() {
    return {
      pedidos: [],
      paidOrders: {},
      unpaindOrders: {},
      dateFilter: {},
      months: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ],
      filtroPendente: false,
    };
  },
  props: {
    searchValue: {
      type: String,
    },
  },
  computed: {
    pedidosPago() {
      const pedidosPago = this.pedidos.filter((pedido) => pedido.is_paid);

      const allOrders = {};
      pedidosPago.forEach((pedido) => {
        const clientCity = pedido.client.city.name.toUpperCase();

        if (Object.keys(allOrders).includes(clientCity)) {
          allOrders[clientCity].push(pedido);
        } else {
          allOrders[clientCity] = [pedido];
        }
      });
      return allOrders;
    },
    pedidosPendentes() {
      const pedidosPago = this.pedidos.filter((pedido) => !pedido.is_paid);

      const allOrders = {};
      pedidosPago.forEach((pedido) => {
        const clientCity = pedido.client.city.name.toUpperCase();

        if (Object.keys(allOrders).includes(clientCity)) {
          allOrders[clientCity].push(pedido);
        } else {
          allOrders[clientCity] = [pedido];
        }
      });
      return allOrders;
    },
  },
  methods: {
    handleDateChange(data) {
      this.dateFilter = data.date;
      this.atualizarPedidos();
    },
    async atualizarPedidos() {
      await Orders().then((response) => {
        this.pedidos = response.data.filter((pedido) => {
          // Data do pedido
          const date = new Date(`${pedido.buy_date}T00:00:00`);
          const month = date.getMonth() + 1;
          const year = date.getFullYear();
          const dateFormated = `${year}-${month}`;

          // Data do filtro
          const index = this.months.indexOf(this.dateFilter.month) + 1;
          const selectedDate = `${this.dateFilter.year}-${index}`;

          return dateFormated === selectedDate;
        });

        this.paidOrders = {};
        this.unpaindOrders = {};

        const pedidosPago = this.pedidos.filter((pedido) => pedido.is_paid);

        pedidosPago.forEach((pedido) => {
          const clientCity = pedido.client.city.name.toUpperCase();
          if (Object.keys(this.paidOrders).includes(clientCity)) {
            this.paidOrders[clientCity].push(pedido);
          } else {
            this.paidOrders[clientCity] = [pedido];
          }
        });

        const pedidosPendentes = this.pedidos.filter(
          (pedido) => !pedido.is_paid
        );

        pedidosPendentes.forEach((pedido) => {
          const clientCity = pedido.client.city.name.toUpperCase();

          if (Object.keys(this.unpaindOrders).includes(clientCity)) {
            this.unpaindOrders[clientCity].push(pedido);
          } else {
            this.unpaindOrders[clientCity] = [pedido];
          }
        });
      });
    },
  },
  created() {
    this.atualizarPedidos();
  },

  watch: {
    filtroPendente() {
      this.atualizarPedidos();
    },
  },
};
</script>

<style scoped>
.pedido-state {
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  font-size: 18px;
  font-weight: 500;
  line-height: normal;
  position: relative; /* Para posicionamento do pseudo-elemento */
}

.pendente-state {
  color: #000;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  font-size: 23px;
  font-weight: 500;
  line-height: normal;
  position: relative; /* Para posicionamento do pseudo-elemento */
}

.pedido-state::after {
  content: '';
  display: block;
  width: 100%;
  height: 2px;
  background-color: #000; /* Cor da linha riscada */
  position: absolute;
  bottom: 0;
  left: 0;
  transform: scaleX(1); /* Começa sem largura */
  transform-origin: bottom left; /* Iniciar do lado esquerdo */
  transition: transform 0.1s;
}

.pendente-state::after {
  content: '';
  display: block;
  width: 100%;
  height: 2px;
  background-color: #000; /* Cor da linha riscada */
  position: absolute;
  bottom: 0;
  left: 0;
  transform: scaleX(1); /* Começa sem largura */
  transform-origin: bottom left; /* Iniciar do lado esquerdo */
  transition: transform 0.1s;
}

.pedido-ativo {
  color: #000;
}

.pedido-ativo::after {
  transform: scaleX(0); /* Quando ativo, exibe a linha riscada */
  transform-origin: bottom right; /* Trocar para o lado direito */
}
</style>
